import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {User} from '../interfaces/users.interface';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UserSessionStorageService } from './user-sessions.service';
import signalR, { HttpTransportType, HubConnection, HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import { GetSourcesResponse } from '../interfaces/source.interface';

@Injectable({providedIn: 'root'})
export class AuthService {
  public currentUser: User | undefined;

  private apiUrl = `${environment.apiUrl}/User`;

  constructor(private http: HttpClient, private sessionService: UserSessionStorageService) { }

  setCurrentUser(user: User | undefined): void {
    this.currentUser = user;
  }

  getToken(request: any) {
    return this.http.post(
      `${this.apiUrl}/GetToken`,
      request,
      { responseType: 'text' }
    );
  }

  connectWithToken(token: string): HubConnection {
    return new HubConnectionBuilder()
      .withUrl(`${environment.hubUrl}`, {
        accessTokenFactory: () => token,
        transport: HttpTransportType.WebSockets,
        skipNegotiation: true,

      })
      .configureLogging(LogLevel.Critical)
      .withAutomaticReconnect()
      .build();
  }

  isTokenValid(): boolean {
    let token = this.sessionService.getItem('access_token');
    if (!token) return false;

    try {
      // base64url → base64
      const base64Url = token.split('.')[1];
      if (!base64Url) return false;

      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const payload = JSON.parse(
        decodeURIComponent(
          atob(base64)
            .split('')
            .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
            .join('')
        )
      );

      const exp = payload.exp * 1000;
      return Date.now() < exp;
    } catch {
      return false;
    }
  }

  isAdmin(): boolean {
    return this.currentUser?.userRole === 'Администратор';
  }

  logOut(): void {
     this.sessionService.removeItem('currentUser');
     this.sessionService.removeItem('access_token');
     window.location.href = '/auth';
  }

}
